window.ManualUpdateAddressForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            textBox: {
                vanityAddress: '#manual-update-address-vanity-address',
                addressLine1: '#manual-update-address-line1',
                addressLine2: '#manual-update-address-line2',
                addressLine3: '#manual-update-address-line3',
                city: '#manual-update-address-city',
                postCode: '#manual-update-address-post-code'
            },
            button:{
                saveAddress: '#save-manual-address'
            },
            label:{
                addressLine1ErrorMessage: '#empty-address-line1',
                cityErrorMessage: '#empty-city',
                postCodeEmptyErrorMessage: '#empty-post-code',
                postCodeInValidErrorMessage: '#invalid-post-code',
                savePostCodeInvalid: '#save-post-code-invalid'
            },
            form:{
                ManualAddressForm:'#manual-update-address-form'
            }
        },
        css: {
            hideElement:'vds-hide'
        },
        urls: {
            personalDetailsPageUrl: '/my-account/details',
            errorPageUrl: '/error/error-page',
            validatePostCodeUrl:'/api/sitecore/UpdateAddress/ValidatePostCode',
            UpdateAddressUrl:'/api/sitecore/UpdateAddress/UpdatePostCodeAddress'
        },
        constants: {
            CharacterLength: 35,
            PostCodeLength: 10,
            ReplaceWhiteSpaceRegex: /\s+/g,
            SplitLastThreeRegex: /(?=.{3}$)/,
            AllowedAddressRegex: '[^a-zA-Z0-9 ]'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.form.ManualAddressForm).on('submit',self.func.handleSaveAddress);
                $(self.elements.textBox.vanityAddress +','+ self.elements.textBox.addressLine1 +','+
                    self.elements.textBox.addressLine2 +','+ self.elements.textBox.addressLine3 +','+
                    self.elements.textBox.city).on('keypress', self.func.allowAlphaNumericAndSpaceOnly);
                $(self.elements.textBox.vanityAddress +','+ self.elements.textBox.addressLine1 +','+
                    self.elements.textBox.addressLine2 +','+ self.elements.textBox.addressLine3 +','+
                    self.elements.textBox.city).on('paste', self.func.allowAddressLinePasting);
                $(self.elements.textBox.postCode).on('input', self.func.allowCapsLetterOnly);
                $(self.elements.textBox.addressLine1).on('input',
                    function () { self.func.hideAddressErrorMessage(self.elements.label.addressLine1ErrorMessage); });
                $(self.elements.textBox.city).on('input',
                    function () { self.func.hideAddressErrorMessage(self.elements.label.cityErrorMessage); });
            },
            allowAlphaNumericAndSpaceOnly: function (event) {
                let regex = new RegExp(self.constants.AllowedAddressRegex);
                    const char = event.key;
                    if (regex.test(char)) {
                        event.preventDefault();
                }
            },
            allowAddressLinePasting: function (event) {
                event.preventDefault();
                const pastedData = event.originalEvent.clipboardData.getData('text');
                if (pastedData) {
                    let regex = new RegExp(self.constants.AllowedAddressRegex, 'g');
                    event.target.value = pastedData.replace(regex, '').slice(0, self.constants.CharacterLength);
                }
            },
            showErrorMessage: function (inputLabel){
                $(inputLabel).removeClass(self.css.hideElement);
            },
            hideAddressErrorMessage: function (inputLabel){
                $(inputLabel).addClass(self.css.hideElement);
            },
            checkIfEmptyAddressLine: function () {
                const addr1   = $(self.elements.textBox.addressLine1);
                const city    = $(self.elements.textBox.city);
                const post    = $(self.elements.textBox.postCode);
                const fields = [
                    { $input: addr1,  errorLabel: self.elements.label.addressLine1ErrorMessage },
                    { $input: city,   errorLabel: self.elements.label.cityErrorMessage },
                    { $input: post,   errorLabel: self.elements.label.postCodeEmptyErrorMessage },
                ];
                fields.forEach(({ $input, errorLabel }) => {
                    const value = ($input.val() || '').toString().trim();
                    if (!value) {
                        self.func.showErrorMessage(errorLabel);
                    }
                });
            },
            handleSaveAddress: function (event) {
                event.preventDefault();
                const addressLine1Val = $(self.elements.textBox.addressLine1).val();
                const addressLine2Val = $(self.elements.textBox.addressLine2).val();
                const addressLine3Val = $(self.elements.textBox.addressLine3).val();
                const cityVal = $(self.elements.textBox.city).val();
                const postCodeVal = $(self.elements.textBox.postCode).val();
                const vanityVal = $(self.elements.textBox.vanityAddress).val();
                if(addressLine1Val && cityVal && postCodeVal
                    && self.func.formattedPostCode()) {
                    const postCodeAddress = {
                        VanityAddressName: vanityVal,
                        Line1: addressLine1Val,
                        Line2: addressLine2Val,
                        Line3: addressLine3Val,
                        Line4: cityVal,
                        PostCode:postCodeVal
                    };
                    self.func.validatePostCode(postCodeAddress);
                }
                else {
                    self.func.checkIfEmptyAddressLine();
                }
            },
            allowCapsLetterOnly: function (e) {
                self.func.hideAddressErrorMessage(self.elements.label.postCodeEmptyErrorMessage);
                self.func.hideAddressErrorMessage(self.elements.label.postCodeInValidErrorMessage);
                const inputValue = e.target.value;
                e.target.value = inputValue.replace(/[^a-zA-Z0-9\s]/g, '')
                    .slice(0,self.constants.PostCodeLength).toUpperCase();
            },
            formattedPostCode: function () {
                const postCodeValue = $(self.elements.textBox.postCode).val();
                const formattedValue = $.trim(postCodeValue)
                    .replace(self.constants.ReplaceWhiteSpaceRegex, '')
                    .toUpperCase().split(self.constants.SplitLastThreeRegex).join(' ');
                $(self.elements.textBox.postCode).val(formattedValue);
                return true;
            },
            validatePostCode: function (request) {
                const formattedPostCode = $(self.elements.textBox.postCode).val();
                $.ajax({
                    type: 'GET',
                    url: self.urls.validatePostCodeUrl+'?postCode='+formattedPostCode,
                    success: function(response) {
                        if(response !== null && response.generalAddressList !== null && response?.generalAddressList.length > 0) {
                            self.func.updateAddress(request);
                        }
                        else {
                            $(self.elements.label.postCodeInValidErrorMessage).removeClass(self.css.hideElement);
                        }
                    },
                    error: function() {
                        $(self.elements.label.postCodeInValidErrorMessage).removeClass(self.css.hideElement);
                    }
                });
            },
            updateAddress: function (request){
                $.ajax({
                    type: 'POST',
                    url: self.urls.UpdateAddressUrl,
                    data: request,
                    success: function(response) {
                        const isAccepted = response.statusCode?.toLowerCase() === self.statusDescription.accepted;
                        window.location.href = isAccepted ? self.urls.personalDetailsPageUrl : self.urls.errorPageUrl;
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('manual-update-address-form' === $('#manual-update-address-form').data('feature')) {
        window.ManualUpdateAddressForm.Init();
    }
});
